import { render, staticRenderFns } from "./ManageAdmin.vue?vue&type=template&id=9335c986"
import script from "./ManageAdmin.vue?vue&type=script&lang=js"
export * from "./ManageAdmin.vue?vue&type=script&lang=js"
import style0 from "./ManageAdmin.vue?vue&type=style&index=0&id=9335c986&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports